// extracted by mini-css-extract-plugin
export default {"LearnMore":"TypewritterAnimation_LearnMore__Z1H43","HiddenText":"TypewritterAnimation_HiddenText__PRJlb","TextBox":"TypewritterAnimation_TextBox__I0G60"};